'use client';

import Image from 'next/image';

import { Breadcrumbs } from '@eliadmin/core/src/components/homepage/breadcrumbs';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function SubpageHeader({
  name,
  slug,
  customTitle,
}: {
  name: string;
  slug: string;
  customTitle?: string;
}) {
  return (
    <section className={cn('relative flex w-full flex-col items-center justify-center')}>
      <div className={cn('custom-section', 'bg-[#FCFBFF] pb-10 pt-10 md:pb-5 lg:pt-[50px]')}>
        <div className="flex w-full flex-col items-center justify-center gap-6">
          <Breadcrumbs
            breadcrumb={{ name, slug }}
            className={{
              wrapper: 'w-full items-center justify-center',
              list: 'w-full items-center justify-center',
            }}
          />
          <h1
            className={cn(
              'h1',
              'text-center font-semibold tracking-tighter text-foreground',
              'ea-heading__title',
            )}
            dangerouslySetInnerHTML={{ __html: customTitle ?? name }}
          />
        </div>
      </div>
      <Image
        src={'/images/subpage-header-vector.svg'}
        alt="Vector"
        width={0}
        height={0}
        className="h-auto w-full object-contain object-center"
      />
    </section>
  );
}
